import "./CaseStudies.module.css";
import Header from "@/reusable_sections/Header";
import Introduction from "./sections/Introduction";
import Gallery from "./sections/Gallery";
import GetStarted from "./sections/GetStarted";
import Footer from "@/reusable_sections/Footer";
export default function CaseStudiesPage() {
  return <div>
      <Header />
      <Introduction />
      <Gallery />
      <GetStarted />
      <Footer />
    </div>;
}